import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { API, errorText } from '../governance_v2/constants';

const ZONES = ['America/Guatemala', 'America/El_Salvador', 'America/Tegucigalpa', 'America/Costa_Rica', 'America/Mexico_City',
  'America/Bogota', 'America/Lima', 'America/Panama', 'America/New_York', 'America/Santiago', 'America/Argentina/Buenos_Aires', 'Europe/Madrid', 'UTC'];

export const BriefingSettingsDialog = ({ companyId, open, onClose }) => {
  const qc = useQueryClient();
  const [form, setForm] = useState({ hour: 7, timezone: 'America/Guatemala' });
  const { data } = useQuery({ queryKey: ['attention', 'settings', companyId], enabled: open,
    queryFn: async () => (await axios.get(`${API}/companies/${companyId}/attention/settings`)).data });
  useEffect(() => { if (data) setForm({ hour: data.hour, timezone: data.timezone }); }, [data]);
  const save = useMutation({
    mutationFn: async () => (await axios.put(`${API}/companies/${companyId}/attention/settings`, form)).data,
    onSuccess: () => { toast.success('Horario del briefing guardado'); qc.invalidateQueries({ queryKey: ['attention'] }); onClose(); },
    onError: (e) => toast.error(errorText(e)),
  });
  const zones = ZONES.includes(form.timezone) ? ZONES : [form.timezone, ...ZONES];
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="briefing-settings-dialog">
        <DialogHeader><DialogTitle>Horario del briefing matutino</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1"><Label className="text-xs">Hora</Label>
            <Select value={String(form.hour)} onValueChange={(v) => setForm((f) => ({ ...f, hour: Number(v) }))}>
              <SelectTrigger data-testid="briefing-hour"><SelectValue /></SelectTrigger>
              <SelectContent>{Array.from({ length: 24 }, (_, h) => <SelectItem key={h} value={String(h)}>{`${String(h).padStart(2, '0')}:00`}</SelectItem>)}</SelectContent>
            </Select></div>
          <div className="space-y-1"><Label className="text-xs">Zona horaria</Label>
            <Select value={form.timezone} onValueChange={(v) => setForm((f) => ({ ...f, timezone: v }))}>
              <SelectTrigger data-testid="briefing-timezone"><SelectValue /></SelectTrigger>
              <SelectContent>{zones.map((z) => <SelectItem key={z} value={z}>{z.replace('America/', '').replace(/_/g, ' ')}</SelectItem>)}</SelectContent>
            </Select></div>
        </div>
        <p className="text-xs text-slate-500">SUPER-100 revisa la empresa cada 15 minutos y genera el briefing una vez al día a esta hora local.</p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="briefing-settings-cancel">Cancelar</Button>
          <Button onClick={() => save.mutate()} disabled={save.isPending} data-testid="briefing-settings-save">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
